import { CoveragePerPlan } from '../../../../../shared/interfaces';

export interface GroupedCoveragesCardsResult {
  [key: string]: {
    title: string | undefined;
    list: Array<CoveragePerPlan>;
  };
}

export const groupCardsByCommonSection = (
  coverageCardsList: Array<CoveragePerPlan>,
  propertyToFilter: keyof CoveragePerPlan,
  defaultKey: string = 'key_default'
) => {
  return coverageCardsList.reduce(
    (result: GroupedCoveragesCardsResult, coverageCard: CoveragePerPlan) => {
      const key = coverageCard.hasOwnProperty(propertyToFilter)
        ? `key_${coverageCard[propertyToFilter]}`
        : defaultKey;
      if (!result[key]) {
        result[key] = {
          title: coverageCard.descripcionFamilia,
          list: [],
        };
      }

      result[key].list.push(coverageCard);

      return result;
    },
    {}
  );
};
